import { ColDef, ICellRendererParams } from "ag-grid-community";
import { SidePanelTableDataComponent } from "./side-panel-table-data.component";
import { CellLinkComponent } from "src/app/common/components/core/table/cell-link.component";
import { AppConstants } from "src/app/common/constants/app-constants";

export const columnDefinitionSidePanelTableData = (
  component: SidePanelTableDataComponent
): ColDef[] => {
  // Default cell renderer function
  const defaultCellRenderer = (params: ICellRendererParams) => `<span title="${params.value}"> ${params.value} <span>` || "—";
  const caseInsensitiveComparator = (valueA: string, valueB: string): number => {
    const a = (valueA ?? AppConstants.emptyString).trim().toLowerCase();
    const b = (valueB ?? AppConstants.emptyString).trim().toLowerCase();
  
    if (a === AppConstants.emptyString && b === AppConstants.emptyString) return 0;
    if (a === AppConstants.emptyString) return -1;
    if (b === AppConstants.emptyString) return 1;
  
    return a.localeCompare(b);
  };
  
  return [
    // Patient Column (conditional)
    ...(component.headerDetails?.[1] ? [
      component.headerDetails[1].isRouteRequired
        ? {
            headerName: component.headerDetails?.[1].headerName,
            field: 'patientName',
            headerClass: "text-sm text-center",
            sortable: true,
            suppressMenu: true,
            cellRenderer: CellLinkComponent,
            cellRendererParams: { 
              clicked: component.navigate.bind(component) 
            },
            flex: 2,
            comparator: caseInsensitiveComparator
          }
        : {
            headerName: component.headerDetails?.[1].headerName,
            field: 'patientName',
            headerClass: "text-sm text-center",
            sortable: true,
            suppressMenu: true,
            cellRenderer: defaultCellRenderer,
            flex: 2,
            comparator: caseInsensitiveComparator
          }
    ] : []),

    // Therapist Column (conditional)
    ...(component.headerDetails?.[2] ? [
      component.headerDetails[2].isRouteRequired
        ? {
            headerName: component.headerDetails[2].headerName,
            field: 'therapistName',
            headerClass: "text-sm text-center",
            sortable: true,
            suppressMenu: true,
            cellRenderer: CellLinkComponent,
            cellRendererParams: { 
              clicked: component.navigate.bind(component) 
            },
            flex: 2,
            comparator: caseInsensitiveComparator
          }
        : {
            headerName: component.headerDetails[2].headerName,
            field: 'therapistName',
            headerClass: "text-sm text-center",
            sortable: true,
            suppressMenu: true,
            cellRenderer: defaultCellRenderer,
            flex: 2,
            comparator: caseInsensitiveComparator
          }
    ] : []),

    // Document Type Column (conditional)
    ...(component.headerDetails?.[3] ? [{
      headerName: component.headerDetails?.[3].headerName,
      field: 'documentType',
      headerClass: "text-sm text-center",
      cellClass: "text-center",
      sortable: true,
      suppressMenu: true,
      cellRenderer: defaultCellRenderer,
      flex: 1.5,
      comparator: caseInsensitiveComparator
    }] : []),

    // Discipline Column (conditional)
    ...(component.headerDetails?.[4] ? [{
      headerName: component.headerDetails?.[4].headerName,
      field: 'discipline',
      headerClass: "text-sm text-center",
      cellClass: "text-center",
      sortable: true,
      suppressMenu: true,
      cellRenderer: defaultCellRenderer,
      flex: 1.5,
    }] : []),

    // Activity Date Column (conditional)
    ...(component.headerDetails?.[5] ? [{
      headerName: component.headerDetails?.[5].headerName,
      field: 'date',
      headerClass: "text-sm text-center",
      cellClass: "text-center",
      sortable: true,
      suppressMenu: true,
      cellRenderer: (params: ICellRendererParams) => {
        if(!!params?.value && params.value != "0001-01-01"){
          const[year, month, date] = params.value.split('-');
          const completeDate = month + "-" + date + "-" + year;
          return `<span title="${completeDate}"> ${completeDate} <span>`
        }
        return AppConstants.emDash
      },
      flex: 2,
    }] : []),
  ].filter(col => col !== undefined && col !== null);
};